import { PropsWithChildren, ReactElement, useContext } from 'react';

import { PanelsContext } from './PanelsContext';

export interface PanelDockProps {
  id: string;
}

export const PanelDock = ({ id, children }: PropsWithChildren<PanelDockProps>): ReactElement => {
  const { setDockElement } = useContext(PanelsContext);

  const setElement = (element: HTMLDivElement) => setDockElement(id, element);

  return (
    <div className={'panelDock'}>
      <div ref={setElement} className={'panelDock-content'} />
      <div className={'panelDock-empty'}>{children}</div>
    </div>
  );
};
